import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent } from '@mui/material';

const LongNoteDialog = (props) => {
  return (
    <Dialog
      maxWidth="sm"
      scroll="paper"
      fullWidth={true}
      open={props.open}
      onClick={() => props.onClose()}
    >
      <DialogContent>{props.note}</DialogContent>
    </Dialog>
  );
};

LongNoteDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  note: PropTypes.string.isRequired,
};
export default LongNoteDialog;
